module.exports = __webpack_public_path__ + "img/Watching.59c59a5b.svg";